import React, { useContext, useEffect, useMemo, useState } from "react";
import { Row, Col, Input, Pagination, Typography, message, Spin } from "antd";
import axios from "axios";
import { Button } from "antd/lib/radio";
import { Content } from "antd/lib/layout/layout";
import { Carrito, SetCarrito } from "../../Hooks/Carrito";
import Compra, { SetCompra } from "../../Hooks/SorteoCompra";
import { OpenModalCompra, SetOpenModalCompra } from "../../Hooks/OpenModalCompra";

const { Title } = Typography;

export default function BoletosPaginados(props) {
  const { total = 0, costo = 0, sorteo_id, sorteo } = props;
  const pageSize = 200;

  const cart = useContext(Carrito);
  const setCart = useContext(SetCarrito);

  const compra = useContext(Compra);
  const setCompra = useContext(SetCompra);

  const openModalCompra = useContext(OpenModalCompra);
  const setOpenModalCompra = useContext(SetOpenModalCompra);

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [boletos, setBoletos] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [searchMode, setSearchMode] = useState(false);

  const digits = useMemo(() => String(total).length, [total]);

  const fetchBoletos = async (p = page, q = busqueda) => {
    if (!sorteo_id) return;
    setLoading(true);
    try {
      // Server-side pagination by page/limit; backend returns aggregatePaginate format
      const params = { page: p, limit: pageSize };
      if (q && q.length > 0) params.busqueda = q;
      const { data } = await axios.get(`/info/${sorteo_id}/boletos-paginados`, { params });
      // Expecting data.docs and data.totalDocs, etc.
      const docs = Array.isArray(data?.docs) ? data.docs : [];
      setBoletos(docs);
      setSearchMode(!!(q && q.length > 0));
      // Optionally could use totalDocs from backend for Pagination total
      if (typeof data?.totalDocs === 'number') {
        setTotalServer(data.totalDocs);
      } else {
        setTotalServer(total);
      }
    } catch (error) {
      message.error(error?.response?.data?.message ?? "Error al obtener los boletos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBoletos(1, "");
    setPage(1);
  }, [sorteo_id, total]);

  const addToCart = (numero) => {
    const copy = Array.isArray(cart) ? [...cart] : [];
    const idx = copy.findIndex((x) => x.numero == numero);
    if (idx === -1) {
      copy.push({ numero, costo, sorteo_id, sorteo });
      message.info(`Boleto no. ${numero} agregado al carrito`);
      setCompra(sorteo);
    } else {
      copy.splice(idx, 1);
      message.info("Boleto eliminado del carrito");
      if (copy.length < 1) setCompra(null);
    }
    setCart(copy);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setBusqueda(value);
    setPage(1);
    fetchBoletos(1, value);
  };

  const filteredBoletos = useMemo(() => {
    // When searching, show all returned with their status. Otherwise show only available
    if (searchMode) return boletos;
    return boletos.filter((b) => !b.vendido);
  }, [boletos, searchMode]);

  const [totalServer, setTotalServer] = useState(total);
  const totalItems = totalServer;
  const pageItems = filteredBoletos;

  return (
    <Content id="boletos-paginados">
      <Row style={{ width: "100%", justifyContent: "center", gap: 20, alignItems: "center", marginBottom: 12 }}>
        <Input
          value={busqueda}
          onChange={handleSearchChange}
          placeholder="Buscar un boleto específico..."
          style={{ maxWidth: 300 }}
          allowClear
        />
        <Title level={5} style={{ margin: 0 }}>
          {busqueda ? "Resultados (incluye vendidos)" : "Mostrando solo disponibles"}
        </Title>
      </Row>
      <Spin spinning={loading} tip="Cargando boletos...">
        <Row className="mt-1" align="middle" justify="center" gutter={[16, 16]}>
          {pageItems.map((boleto) => {
            const { numero, vendido } = boleto;
            const seleccionado = Array.isArray(cart) && cart.find((x) => x.numero == numero);
            return (
              <Col xs={8} sm={4} md={4} lg={2} xl={2} xxl={2} key={numero} className="center">
                <Button
                  className={`button-boleto ${vendido ? "vendido" : seleccionado ? "seleccionado" : ""}`}
                  onClick={() => addToCart(numero)}
                  disabled={vendido}
                >
                  {String(numero).padStart(digits, "0")}
                </Button>
              </Col>
            );
          })}
        </Row>
        <Row style={{ width: "100%", justifyContent: "center", marginTop: 16 }}>
          <Pagination
            current={page}
            pageSize={pageSize}
            total={totalItems}
            showSizeChanger={false}
            onChange={(p) => {
              setPage(p);
              fetchBoletos(p, busqueda);
            }}
          />
        </Row>
      </Spin>
    </Content>
  );
}
